module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mps-admin-widgets vue-rqf bg-loading",
    attrs: {
      "loading": _vm.$root.ui.loading
    }
  }, [_c('div', {
    staticClass: "mps-widgets-columns"
  }, [_c('div', {
    staticClass: "mps-widgets-column"
  }, [(_vm.workshops.length) ? _c('div', {
    staticClass: "mps-admin-widget"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mps-admin-padding"
  }, [_c('ul', {
    staticClass: "mps-admin-list"
  }, [_vm._l((_vm.workshops), function(ws, wsIdx) {
    return [_c('li', {
      staticClass: "mps-entity-item",
      attrs: {
        "status": ws.status
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(ws.name)
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": '#/workshop/' + ws.id
      }
    }, [_vm._v("Rediger")])])]
  })], 2)]), _vm._v(" "), (_vm.$root.isAdminUser()) ? _c('footer', {
    staticClass: "mps-admin-padding"
  }, [_c('a', {
    staticClass: "mps-admin-btn",
    attrs: {
      "href": "#/workshop"
    }
  }, [_vm._v("Legg til")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.workshopInfo) ? _c('div', {
    staticClass: "mps-admin-widget"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mps-admin-padding"
  }, [_c('ul', {
    staticClass: "mps-admin-list"
  }, [_c('li', {
    staticClass: "mps-highlight"
  }, [_c('b', {
    domProps: {
      "textContent": _vm._s(_vm.workshopInfo.name)
    }
  })]), _vm._v(" "), _c('li', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.workshopInfo.email)
    }
  })]), _vm._v(" "), _c('li', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.workshopInfo.phone)
    }
  })]), _vm._v(" "), _c('li', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.workshopInfo.street)
    }
  })]), _vm._v(" "), _c('li', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.workshopInfo.postal + ' ' + _vm.workshopInfo.city)
    }
  })]), _vm._v(" "), _c('li', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.workshopInfo.county)
    }
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('span', {
    domProps: {
      "textContent": _vm._s('Longitude: ' + (_vm.workshopInfo.longitude + 0))
    }
  })]), _vm._v(" "), _c('li', [_c('span', {
    domProps: {
      "textContent": _vm._s('Latitude: ' + (_vm.workshopInfo.latitude + 0))
    }
  })])])]), _vm._v(" "), _c('footer', {
    staticClass: "mps-admin-padding"
  }, [_c('a', {
    staticClass: "mps-admin-btn",
    attrs: {
      "href": '#/workshop/' + _vm.workshopInfo.id
    }
  }, [_vm._v("Rediger")])])]) : _vm._e(), _vm._v(" "), (_vm.$root.isAdminUser() && _vm.companies.length) ? _c('div', {
    staticClass: "mps-admin-widget"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "mps-admin-padding"
  }, [_c('ul', {
    staticClass: "mps-admin-list"
  }, [_vm._l((_vm.companies), function(c, wsIdx) {
    return [_c('li', {
      staticClass: "mps-entity-item",
      attrs: {
        "status": c.status,
        "partner": c.is_partner,
        "fleet": c.is_fleet
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(c.name + (c.type_slug ? ' (' + c.type_slug + ')' : ''))
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": '#/company/' + c.id
      }
    }, [_vm._v("Rediger")])])]
  })], 2)]), _vm._v(" "), _vm._m(4)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mps-widgets-column"
  }, [(_vm.requests.length) ? _c('div', {
    staticClass: "mps-admin-widget"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "mps-admin-padding"
  }, [_vm._l((_vm.requests), function(request, requestIndex) {
    return [_c('a', {
      staticClass: "mps-admin-widget-item",
      attrs: {
        "target": "_blank",
        "href": _vm.requestsNewUri + '/request/admin/' + request.code
      }
    }, [_c('div', [_c('b', {
      staticClass: "mps-highlight",
      domProps: {
        "textContent": _vm._s(request.contact_name)
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "upcase",
      domProps: {
        "textContent": _vm._s((request.car_id ? request.car_id : '') + (request.car_model ? (' - ' + request.car_producer + ' ' + request.car_model + ' ' + request.car_year) : ''))
      }
    })]), _vm._v(" "), _c('div', [_c('span', {
      domProps: {
        "textContent": _vm._s(request.date)
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(request.time)
      }
    })])])]
  })], 2), _vm._v(" "), _c('footer', {
    staticClass: "mps-admin-padding"
  }, [_c('a', {
    staticClass: "mps-admin-btn",
    attrs: {
      "href": _vm.requestsNewUri
    }
  }, [_vm._v("Ny hurtigtakst")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.requestsAllUri
    }
  }, [_vm._v("Vis alle")])])]) : _vm._e(), _vm._v(" "), (_vm.reports.length) ? _c('div', {
    staticClass: "mps-admin-widget"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "mps-admin-padding"
  }, [_vm._l((_vm.reports), function(report, reportIndex) {
    return [_c('a', {
      staticClass: "mps-admin-widget-item",
      attrs: {
        "target": "_blank",
        "href": _vm.reportsAllUri + '/' + report.id
      }
    }, [_c('div', [_c('b', {
      staticClass: "mps-highlight",
      domProps: {
        "textContent": _vm._s(report.surveyor_name)
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "upcase",
      domProps: {
        "textContent": _vm._s(report.car_id)
      }
    })]), _vm._v(" "), _c('div', [_c('span', {
      domProps: {
        "textContent": _vm._s(report.date)
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(report.time)
      }
    })])])]
  })], 2), _vm._v(" "), _c('footer', {
    staticClass: "mps-admin-padding"
  }, [_c('a', {
    staticClass: "mps-admin-btn",
    attrs: {
      "href": _vm.reportsNewUri
    }
  }, [_vm._v("Ny takst")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.reportsAllUri
    }
  }, [_vm._v("Vis alle")])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "mps-admin-padding"
  }, [_c('h4', [_vm._v("Verksteder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "mps-admin-padding"
  }, [_c('h4', [_vm._v("Verksted kontaktinfo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('b', [_vm._v("Kart:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "mps-admin-padding"
  }, [_c('h4', [_vm._v("Companies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "mps-admin-padding"
  }, [_c('a', {
    staticClass: "mps-admin-btn",
    attrs: {
      "href": "#/company"
    }
  }, [_vm._v("Legg til")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "mps-admin-padding"
  }, [_c('h4', [_vm._v("Prisforespørsler")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "mps-admin-padding"
  }, [_c('h4', [_vm._v("PreTakst")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d8d76ba4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./requests/assets/src/components/Widgets.vue
// module id = 121
// module chunks = 0